import * as React from "react";
import { Link } from "react-router-dom";
import { getSocialMediaCoordinates } from "src/scripts/utility";
import { socialMediaData } from "public/data/socialMedia";
import { SocialMediaIcon } from "./spriteWrappers";

interface SocialMediaLinkProperties {
	to: string;
	platform: string;

	style?: object;
	name?: string;
	className?: string;
}

export function SocialMediaLink(props: SocialMediaLinkProperties) {
	// const coordinates = getSocialMediaCoordinates(props.platform);
	const platformName = socialMediaData[props.platform].name;
	return (
		<Link 
		className={"social-media-link" + (props.className ? ` ${props.className}` : "")} 
		target="_blank" 
		to={props.to}
		aria-label={props.name ? `Follow ${props.name} on ${platformName}` : undefined} // unsure if this makes for a great user experience
		title={props.name ? `Follow ${props.name} on ${platformName}` : undefined}
		style={{
			...props.style,
			// "--position-x": coordinates[0],
			// "--position-y": coordinates[1]
		}}>
			<SocialMediaIcon slug={props.platform}/>
		</Link>
	)
}
